import React, { useState, useEffect } from 'react';
import { Form, Button, InputGroup, FormControl, Card, Row, Col, Spinner } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone'; // React Dropzone import
import avatarImg from 'assets/img/team/avatar.png';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import { useAuthWizardContext } from 'providers/AuthWizardProvider';
import 'react-toastify/dist/ReactToastify.css'; // 추가
import 'safedb/common/css/IniCustomCss.css';
import CheckOutModal from 'components/modal/CheckOutModal';
import { AiFillCloseCircle } from 'react-icons/ai';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { PiWarningCircle } from 'react-icons/pi';
import { createCompany, ImagesUpload, fetchImageByUuid } from 'hooks/CallApi'; // API 함수 임포트
import { formatDate } from 'components/common/SunnyUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretSquareLeft } from '@fortawesome/free-solid-svg-icons';
import {
  handleValueDelete,
  goToParentPath,
  formatPhoneNumber,
  validatePhoneNumber,
  handlePhoneChange
} from 'components/common/SunnyUtils';
import { useAppContext } from 'providers/AppProvider';
import styled from 'styled-components';

// UUID 형태인지 판별하는 함수
const isValidUUID = (str) => {
  if (!str || typeof str !== 'string') return false;
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
};

const AddAdmimSites = ({ setValue }) => {
  const {
    config: { userAuth }
  } = useAppContext();

  const [modalCancelShow, setModalCancelShow] = useState(false);
  const [modalConfirmShow, setModalConfirmShow] = useState(false);
  const [isArrowHovered, setIsArrowHovered] = useState(false);

  const [modalConfirmCheckShow, setModalConfirmCheckShow] = useState(false);
  const [isChevronUp, setIsChevronUp] = useState(false); // 상태 변수 추가
  const toggleKeyPart = () => {
    setKeyPart(!KeyPart);
    setIsChevronUp(!isChevronUp); // 아이콘 상태 전환
  };
  const [KeyPart, setKeyPart] = useState(true);
  const [NameError, setNameError] = useState('');
  const [DescError, setDescError] = useState('');
  const [MailError, setMailError] = useState('');
  const [AddrError, setAddrError] = useState('');
  const [isInvalid, setIsInvalid] = useState(false); // 유효성 검사 상태
  const [isUploading, setIsUploading] = useState(false); // 업로드 로딩 상태

  const [isHovered, setIsHovered] = useState(false);
  // const handleMouseEnter = () => setIsHovered(true);

  const handleMouseEnter = () => {
    if (userAuth === 'SA' || userAuth === 'ADMIN') {
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => setIsHovered(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // 내용 변경 시 변경 버튼 눌렀을때
  const handleSubmitClick = () => {
    e.preventDefault();
    setModalConfirmShow(true);
  };

  const handleConfirm = async () => {
    try {
      const response = await createCompany({
        imgUrl: formData.imgUrl,
        name: formData.clientName,
        tel: formData.clientPhone,
        email: formData.clientEmail,
        address: formData.clientAddress,
        description: formData.description
      });
      if (response) {
        setModalConfirmShow(false);
        setModalConfirmCheckShow(true);
        // alert('정상 등록되었습니다.');
      }
    } catch (error) {
      alert('회사 생성 중 오류가 발생했습니다.');
    }
    navigate(-1);
  };

  const navigate = useNavigate(); // useNavigate 훅 사용
  const handleCancel = () => {
    navigate(`/safedb/SA/adminSites`); // 데이터와 함께 이동
  };
  const [PhoneError, setPhoneError] = useState(''); // 연락처 에러 메시지

  const [formData, setFormData] = useState({
    createdAt: '',
    updateAt: '',
    description: '',
    imgUrl: '',
    active: '',
    clientName: '',
    clientEmail: '',
    clientPhone: '',
    clientAddress: '',
    clientSecret: '',
    clientKey: '',
    clientIV: ''
  });
  const { user } = useAuthWizardContext();

  const [avatar, setAvatar] = useState([
    ...(user.avatar ? user.avatar : []),
    { src: avatarImg }
  ]);

  const handleChange = e => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });

    // 각각의 에러
    if (name === 'clientEmail') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        setMailError('올바른 이메일 형식이 아닙니다.');
      } else if (value.length >= 50) {
        setMailError('고객사 메일은 최대 50자까지 입력 가능합니다.');
      } else {
        setMailError('');
      }
    }

    if (name === 'clientName') {
      if (value.length >= 50) {
        setNameError(`고객사명은 최대 50자까지 입력 가능합니다.`);
      } else {
        setNameError('');
      }
    }

    if (name === 'clientAddress') {
      if (value.length >= 100) {
        setAddrError(`고객사 주소는 최대 100자까지 입력 가능합니다.`);
      } else {
        setAddrError('');
      }
    }

    if (name === 'description') {
      if (value.length >= 800) {
        setDescError(`고객사 설명란 입력은 최대 800자까지 입력 가능합니다.`);
      } else {
        setDescError('');
      }
    }

    if (name === 'clientPhone') {
      handlePhoneChange(value, formData, setFormData, setPhoneError, setIsInvalid);
      return;
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
  };


  const onDrop = async acceptedFiles => {
    if (userAuth === 'SA' || userAuth === 'ADMIN') {
      if (acceptedFiles.length > 0 && !isUploading) { // 업로드 중이 아닐 때만 처리
        const imageFile = acceptedFiles[0];
        const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
        if (imageFile.size > MAX_FILE_SIZE) {
          alert('이미지 크기는 최대 5MB까지 허용됩니다.');
          return;
        }

        // 업로드 시작
        setIsUploading(true);

        // 미리보기 URL을 try 블록 밖에서 선언
        let previewUrl;

        try {
          // 미리보기 즉시 반영
          previewUrl = URL.createObjectURL(imageFile);
          setAvatar([{ src: previewUrl }]);

          // API 업로드 실행
          const uploadResponse = await ImagesUpload(imageFile, 'company');

          if (uploadResponse && uploadResponse.data.imageUrl) {
            const uploadedImageUrl = uploadResponse.data.imageUrl;

            // formData 업데이트
            setFormData(prev => ({
              ...prev,
              imgUrl: uploadedImageUrl
            }));

            // UUID인지 확인하고 적절히 처리
            if (isValidUUID(uploadedImageUrl)) {
              // UUID라면 fetchImageByUuid로 Blob URL 가져와서 표시
              try {
                const blobUrl = await fetchImageByUuid(uploadedImageUrl);
                if (blobUrl) {
                  setAvatar([{ src: blobUrl }]);
                } else {
                  // fetchImageByUuid 실패 시 미리보기 유지
                  console.warn('UUID 이미지 로딩 실패, 미리보기 유지');
                }
              } catch (error) {
                console.warn('UUID 이미지 로딩 실패, 미리보기 유지:', error);
              }
            } else {
              // 일반 URL이라면 직접 사용
              setAvatar([{ src: uploadedImageUrl }]);
            }

            // 미리보기 URL 정리 (메모리 누수 방지)
            URL.revokeObjectURL(previewUrl);

            // setIsChanged(true); // Mark as changed
          } else {
            throw new Error('이미지 업로드에 실패했습니다.');
          }
        } catch (error) {
          console.error('이미지 업로드 에러:', error);
          alert('이미지 업로드에 실패했습니다.');
          // 에러 발생 시에도 미리보기 URL 정리 (존재하는 경우에만)
          if (previewUrl) {
            URL.revokeObjectURL(previewUrl);
          }
        } finally {
          // 업로드 완료 (성공/실패 무관)
          setIsUploading(false);
        }
      }
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      'image/jpeg': ['.jpeg', '.jpg'],
      'image/png': ['.png'],
      'image/gif': ['.gif'],
      'image/svg+xml': ['.svg']
    },
    disabled: !(userAuth === 'SA' || userAuth === 'ADMIN') || isUploading // Dropzone 비활성화 (권한 없거나 업로드 중일 때)
  });

  const isFormValid = () => {
    if (!formData) return false;

    const { clientName, clientPhone, clientEmail, clientAddress } = formData;
    const phoneValidation = validatePhoneNumber(clientPhone);

    return (
      typeof clientName === 'string' && clientName.trim() !== '' &&
      typeof clientPhone === 'string' && clientPhone.trim() !== '' &&
      phoneValidation.isValid &&
      typeof clientEmail === 'string' && clientEmail.trim() !== '' &&
      typeof clientAddress === 'string' && clientAddress.trim() !== '' &&
      !NameError &&
      !PhoneError &&
      !MailError &&
      !AddrError &&
      !isInvalid
    );
  };

  const handleDateChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value // 이미 'YYYY-MM-DDTHH:MM' 형식으로 제공됨
    });
  };


  return (
    <div className="container mt-5">
      <Card className="mypage-card">
        <Card.Header className="px-3" as="h4">
          <Link
            to={goToParentPath()}
            style={{ textDecoration: 'none', color: 'inherit' }}
            onMouseEnter={() => setIsArrowHovered(true)}
            onMouseLeave={() => setIsArrowHovered(false)}
          >
            <FontAwesomeIcon
              icon={faCaretSquareLeft}
              className="me-2"
              style={
                isArrowHovered
                  ? {} // Hover 시 스타일 제거
                  : { color: '#869fca' } // 기본 스타일
              }
            />
          </Link>
          고객사 관리
        </Card.Header>
        <Card.Title className="border border-bottom-0 px-3 pt-3">
          {' '}
          정보 등록
        </Card.Title>
        <Card.Body className="border border-top-0">
          <Form
            onSubmit={e => {
              e.preventDefault();
              setModalConfirmShow(true);
            }}
          >
            <Row>
              {/* Left Column (Profile Image) */}
              <Col md={4} className="text-center profile-section">
                <div
                  {...getRootProps({ className: 'dropzone' })}
                  style={{
                    cursor: isUploading
                      ? 'not-allowed'
                      : (userAuth === 'SA' || userAuth === 'ADMIN' ? 'pointer' : 'not-allowed'),
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '150px',
                    height: '150px',
                    position: 'relative',
                    margin: '0 auto',
                    opacity: isUploading ? 0.7 : 1
                  }}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <input {...getInputProps()} />

                  {isUploading ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                      <Spinner animation="border" size="sm" />
                      <small style={{ color: '#6c757d' }}>업로드 중...</small>
                    </div>
                  ) : (
                    <Profile>
                      <Image
                        src={avatar.length > 0 ? avatar[0].src : cloudUpload}
                        alt=""
                      />
                      <HoverView>이미지 변경</HoverView>
                    </Profile>
                  )}
                </div>
              </Col>

              {/* Right Column (ID, Password, Name) */}
              <Col md={8}>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        고객사명<span className="text-danger">*</span>
                      </Form.Label>
                      <div
                        style={{
                          position: 'relative'
                        }}
                      >
                        <Form.Control
                          type="text"
                          name="clientName"
                          value={formData.clientName}
                          onChange={handleChange}
                          className="input-hover"
                          maxLength="50"
                          style={{
                            paddingRight: '30px'
                          }}
                        //  placeholder="아이디를 입력해주세요."
                        />

                        {formData.clientName && (
                          <span
                            onClick={e =>
                              handleValueDelete(
                                'clientName',
                                formData,
                                setFormData
                              )
                            }
                            style={{
                              cursor: 'pointer',
                              position: 'absolute',
                              right: '10px',
                              top: '50%',
                              transform: 'translateY(-14px)',
                              zIndex: 9
                            }}
                          >
                            <AiFillCloseCircle />
                          </span>
                        )}
                      </div>
                    </Form.Group>
                    {NameError && (
                      <span className="text-danger">{NameError}</span>
                    )}{' '}
                    {/* 에러 메시지 표시 */}
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        고객사 연락처<span className="text-danger">*</span>
                      </Form.Label>
                      <div
                        style={{
                          position: 'relative'
                        }}
                      >
                        {/* <InputGroup> */}
                        <Form.Control
                          type="phone"
                          name="clientPhone"
                          value={formData.clientPhone}
                          onChange={handleChange}
                          className="input-hover"
                          maxLength="20"

                        />

                        {formData.clientPhone && (
                          <span
                            onClick={e =>
                              handleValueDelete(
                                'clientPhone',
                                formData,
                                setFormData
                              )
                            }
                            style={{
                              cursor: 'pointer',
                              position: 'absolute',
                              right: '10px',
                              // top: isInvalid ? '35%' : '50%',
                              top: '50%',
                              transform: 'translateY(-14px)',
                              zIndex: 9
                            }}
                          >
                            <AiFillCloseCircle />
                          </span>
                        )}
                      </div>
                    </Form.Group>
                    {PhoneError && (
                      <span className="text-danger">{PhoneError}</span>
                    )}{' '}
                    {/* 에러 메시지 표시 */}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        고객사 메일<span className="text-danger">*</span>
                      </Form.Label>
                      <div
                        style={{
                          position: 'relative'
                        }}
                      >
                        <Form.Control
                          type="text"
                          name="clientEmail"
                          value={formData.clientEmail}
                          onChange={handleChange}
                          className="input-hover"
                          maxLength="50"
                          style={{
                            paddingRight: '30px'
                          }}
                        // placeholder="이름을 입력해주세요."
                        />

                        {formData.clientEmail && (
                          <span
                            onClick={e =>
                              handleValueDelete(
                                'clientEmail',
                                formData,
                                setFormData
                              )
                            }
                            style={{
                              cursor: 'pointer',
                              position: 'absolute',
                              right: '10px',
                              top: '50%',
                              transform: 'translateY(-14px)',
                              zIndex: 9
                            }}
                          >
                            <AiFillCloseCircle />
                          </span>
                        )}
                      </div>
                    </Form.Group>
                    {MailError && (
                      <span className="text-danger">{MailError}</span>
                    )}{' '}
                    {/* 에러 메시지 표시 */}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        고객사 주소<span className="text-danger">*</span>
                      </Form.Label>
                      <div
                        style={{
                          position: 'relative'
                        }}
                      >
                        <Form.Control
                          type="text"
                          name="clientAddress"
                          value={formData.clientAddress}
                          onChange={handleChange}
                          className="input-hover"
                          maxLength="100"
                          style={{
                            paddingRight: '30px'
                          }}
                        // placeholder="이름을 입력해주세요."
                        />

                        {formData.clientAddress && (
                          <span
                            onClick={e =>
                              handleValueDelete(
                                'clientAddress',
                                formData,
                                setFormData
                              )
                            }
                            style={{
                              cursor: 'pointer',
                              position: 'absolute',
                              right: '10px',
                              top: '50%',
                              transform: 'translateY(-14px)',
                              zIndex: 9
                            }}
                          >
                            <AiFillCloseCircle />
                          </span>
                        )}
                      </div>
                    </Form.Group>
                    {AddrError && (
                      <span className="text-danger">{AddrError}</span>
                    )}{' '}
                    {/* 에러 메시지 표시 */}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>등록 일시</Form.Label>
                      <Form.Control
                        // type="datetime-local"
                        type="text"
                        name="addDate"
                        // value={formData.createdAt}
                        value={formatDate(formData.createdAt)} // 저장된 형식 그대로 사용
                        disabled
                      // onChange={handleDateChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>수정 일시</Form.Label>
                      <Form.Control
                        type="text"
                        name="editDate"
                        value={formatDate(formData.updateAt)}
                        disabled
                      // onChange={handleDateChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3" style={{ position: 'relative' }}>
                  <Form.Label>설명</Form.Label>
                  <div
                    style={{
                      position: 'relative'
                    }}
                  >
                    <Form.Control
                      as="textarea"
                      name="description"
                      rows={1}
                      value={formData.description}
                      onChange={handleChange}
                      className="input-hover"
                      maxLength="800"
                    />

                    {formData.description && (
                      <span
                        onClick={e =>
                          handleValueDelete(
                            'description',
                            formData,
                            setFormData
                          )
                        }
                        style={{
                          cursor: 'pointer',
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-14px)',
                          zIndex: 9
                        }}
                      >
                        <AiFillCloseCircle />
                      </span>
                    )}
                  </div>
                  {DescError && <div style={{ color: 'red' }}>{DescError}</div>}{' '}
                  {/* 에러 메시지 표시 */}
                </Form.Group>
              </Col>
            </Row>

            {/* Cancel and Confirm Buttons */}
            <div className="d-flex justify-content-end mt-3">
              {/* <Button variant="secondary" className="mx-3" onClick={handleDeleteRe} style={{ width: '7rem', whiteSpace: 'nowrap' }}>
                관리 키 설정
              </Button> */}
              {/* <Button className="mx-2" variant="outline-danger" onClick={() => setModalCancelShow(true)} style={{ width: '7rem' }}>
                취소
              </Button> */}
              <Button
                variant="primary"
                type="submit"
                disabled={!isFormValid()}
                style={{ width: '7rem' }}
              >
                등록
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>

      <CheckOutModal
        show={modalCancelShow}
        onHide={() => setModalCancelShow(false)}
        onConfirm={handleCancel}
        title="확인" // 제목
        body="진행 중인 작업을 취소하시겠습니까?"
        variant="info"
        cancelText="취소" // 취소 버튼 텍스트
        confirmText="확인" // 확인 버튼 텍스트
        CancelButton={true}
        SubmitButton={true}
      />

      <CheckOutModal
        show={modalConfirmShow}
        onHide={() => setModalConfirmShow(false)}
        onConfirm={handleConfirm}
        title="확인" // 제목
        variant="info"
        body="고객사 정보를 등록하시겠습니까?" // 본문 내용
        cancelText="취소" // 취소 버튼 텍스트
        confirmText="확인" // 확인 버튼 텍스트
        CancelButton={true}
        SubmitButton={true}
      />

      <CheckOutModal
        show={modalConfirmCheckShow}
        onHide={() => setModalConfirmCheckShow(false)}
        variant="success"
        onConfirm={handleConfirm}
        title="확인" // 제목
        body="등록이 완료 되었습니다."
        SubmitButton={true}
      />
    </div>
  );
};

export default AddAdmimSites;

const Profile = styled.div`
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const HoverView = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: white;
  transition: all 0.1s;
  background-color: #2229;
  user-select: none;
  opacity: 0;

  &:hover {
    opacity: 1;
  }
`;
